var map = {
	"./battery_1blue.png": "559e",
	"./battery_1classic.png": "7ae4",
	"./battery_1disable.png": "cbe95",
	"./battery_1green.png": "277c",
	"./battery_1orange.png": "febf",
	"./battery_1purple.png": "7b97"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d879";